import {
    GET_SUPPORT_CREATE_FAIL,
    GET_SUPPORT_CREATE_SUCCESS,
    RESET_SUPPORT_ACTION_STATE,
    RESET_SUPPORT_STATE,
} from "./actionTypes"

const INIT_STATE = {
    supportCreate: [],
    error: [],
}

const Support = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_SUPPORT_CREATE_SUCCESS:
            return {
                ...state,
                supportCreate: action.payload
            }
        case GET_SUPPORT_CREATE_FAIL:
            return {
                ...state,
                error: action.payload,
                supportCreate: action.payload,
            }

        case RESET_SUPPORT_ACTION_STATE:
            return {
                ...state,
                supportCreate: [],
                error: [],
            }
        case RESET_SUPPORT_STATE:
            return {
                ...state,
                supportCreate: [],
                error: [],
            }
        default:
            return state
    }
}

export default Support
